import { render } from "./AppBar.vue?vue&type=template&id=3c794b5d"
import script from "./AppBar.vue?vue&type=script&lang=js"
export * from "./AppBar.vue?vue&type=script&lang=js"
script.render = render

export default script